"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const InputWidget_1 = tslib_1.__importDefault(require("../widget/InputWidget"));
const fmko_ts_common_1 = require("fmko-ts-common");
const KeyboardEventCodes_1 = require("../../util/KeyboardEventCodes");
/**
 * @deprecated use {@link WCAGNumberField} instead.
 */
class NumberField extends InputWidget_1.default {
    constructor(element) {
        super(element);
        this.numberOfDecimals = NumberField.decimals;
        this.init();
    }
    parseValueFromInput(v) {
        if (!v || v.length === 0) {
            return null;
        }
        let parsed;
        if (this.allowDecimals) {
            parsed = parseFloat(v.replace(",", "."));
        }
        else {
            parsed = parseInt(v, 10);
        }
        if (isNaN(parsed)) {
            return null;
        }
        return parsed;
    }
    decorateElement(element) {
        element.type = "text";
        element.classList.add("field", "numberField");
        element.addEventListener("focus", () => element.select());
    }
    setValueOnInput(value, input) {
        // Update field value
        if (value === null || value === undefined) {
            input.value = "";
        }
        else if (this.allowDecimals) {
            input.value = (new fmko_ts_common_1.DecimalFormatter(this.numberOfDecimals, !this.decimalsRequired)).format(value);
        }
        else {
            input.value = NumberField.integerFormat.format(value);
        }
    }
    init() {
        const field = this.getInput();
        this.getInput().addEventListener("keypress", (e) => {
            if (e.ctrlKey || e.which === 0 || e.keyCode === 8) {
                // FireFox generates (blockable) keypress events for tab, backspace, arrow keys, and control inputs,
                // so we need to allow these
                return;
            }
            const ch = (0, KeyboardEventCodes_1.getChar)(e);
            const pos = field.selectionStart;
            if (!this.isValidNextChar(field.value, ch, pos, field.selectionEnd)) {
                e.preventDefault();
            }
        });
        this.getInput().addEventListener("paste", () => {
            setTimeout(() => {
                if (!this.isValid(field.value)) {
                    field.value = "";
                }
            });
        });
    }
    isValidNextChar(oldValue, ch, cursorPosStart, cursorPosEnd) {
        if (oldValue != null) {
            let entireValueSelected = oldValue.substr(cursorPosStart, cursorPosEnd) !== oldValue;
            if (entireValueSelected && oldValue.substring(cursorPosStart).startsWith("-")) {
                return false;
            }
        }
        if ((ch >= "0" && ch <= "9")) {
            return true;
        }
        if (this.allowDecimals && (ch === "," || ch === ".")) {
            if (!oldValue || !(oldValue.indexOf(",") > -1 || oldValue.indexOf(".") > -1)) {
                return true;
            }
        }
        if (this.allowNegative && ch === "-") {
            if (!oldValue) {
                return true;
            }
            if (!oldValue.startsWith("-")) {
                const prefix = oldValue.substring(0, cursorPosStart).trim();
                if (prefix.length === 0) {
                    return true;
                }
            }
        }
        return false;
    }
    isValid(value) {
        const chars = value.split("");
        let s = "";
        for (let char of chars) {
            if (!this.isValidNextChar(s, char, s.length, s.length)) {
                return false;
            }
            s += char;
        }
        return true;
    }
}
NumberField.decimals = 2;
NumberField.integerFormat = new fmko_ts_common_1.IntegerFormatter();
exports.default = NumberField;
//# sourceMappingURL=NumberField.js.map